// features/counter/counterSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// Define the state type
interface Dir {
    id: string;
    value: number;
}

// Define the state type
interface DirState {
    directives: Dir[];
}
  

// Initial state
const initialState: DirState = {
    directives: [],
};

const directiveSlice = createSlice({
  name: 'dir',
  initialState,
  reducers: {
    setDirective: (state, action: PayloadAction<{ id: string; value: number }>) => {
        const dir = state.directives.find((dir) => dir.id === action.payload.id);
        if (dir) {
            dir.value = action.payload.value;
        }
      },
  },
});

// Export actions
export const { setDirective } = directiveSlice.actions;

// Export reducer
export default directiveSlice.reducer;